import { AxiosInstance } from 'axios'

import { HalvesPage, WholePizza } from '@/types/api/api-v3/halves'
import { Mode } from '@/types/main'

import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '~/api/results'

export function createHalvesService({
  axios,
  sentry,
  city,
  hostname,
}: {
  axios: AxiosInstance
  sentry: any
  city: string
  hostname: string
}) {
  // Формируем новый url для v4
  const { API_BASE_URL, API_BASE_URL_KG, BRAND_UUID, MODE } =
    useRuntimeConfig().public

  const API_URL = getApiUrl(
    API_BASE_URL as string,
    API_BASE_URL_KG as string,
    MODE as Mode,
    hostname,
  )

  const API_URL_V4 = `${API_URL}/v4/${BRAND_UUID}/${city}`

  return {
    async fetchHalvesPizza() {
      try {
        const { data } = await axios.get<HalvesPage>(
          `${API_URL_V4}/halves/components/`,
        )

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так')
        }
      }
    },

    async fetchWholePizzas(halvesDetailId: number) {
      try {
        const { data } = await axios.get<WholePizza[]>(
          `${API_URL_V4}/halves/${halvesDetailId}/`,
        )

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так')
        }
      }
    },
  }
}
